import { entityType } from '../constants';

export const rowColorStyle = record => ({
  backgroundColor: record.entityType === entityType.demo ? 'rgba(50, 167, 205, 0.2)' : 'white',
});
